import axios from 'axios';

export const API_URL = "https://divinefoodservice-1.onrender.com";

// export const API_URL = "http://localhost:5454";

export const api = axios.create({
  baseURL: API_URL, 
  headers: {
    'Content-Type': 'application/json',
  },
});


